import {Component, OnInit} from '@angular/core';
import {MenuItem} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-shared-resources',
  templateUrl: './shared-resources.component.html',
  styleUrls: ['./shared-resources.component.scss']
})
export class SharedResourcesComponent implements OnInit {

  public navState: any;

  public items: MenuItem[];
  public activeItem: MenuItem;
  public activeItemIndex: number;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private translocoService: TranslocoService) {
    const navigation = this.router.getCurrentNavigation();
    if (!navigation?.extras.state) {
      this.navState = navigation?.previousNavigation?.extras.state;
    } else {
      this.navState = navigation?.extras.state;
    }
  }

  ngOnInit(): void {
    this.translocoService.selectTranslate('model.device').subscribe(() => {
      this.items = [
        {id: 'sharedWithMe', label: this.translocoService.translate('model.sharedWithMe'), icon: 'pi pi-user'},
        {id: 'sharedByUser', label: this.translocoService.translate('model.sharedByUser'), icon: 'pi pi-users'}
      ];

      this.items.forEach(item => {
        this.translocoService.selectTranslate(item.label).subscribe(value => {
          return item.label = value;
        });
      });

      if (this.navState && this.navState.showView) {
        this.activeItemIndex = this.items.indexOf(this.items.filter(item => item.id === this.navState.showView)[0]);
        this.activeItem = this.items[this.activeItemIndex];
      } else {
        this.activeItemIndex = 0;
        this.activeItem = this.items[this.activeItemIndex];
      }
    });
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
    this.activeItemIndex = this.items.indexOf(this.activeItem);
  }
}
